import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import ParkingPartnerFields from "./ParkingPartnerFields";

export const ParkingPartnerCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <ParkingPartnerFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default ParkingPartnerCreate
